import { Component, OnInit } from "@angular/core";
import { BorderObject } from "../classes/border-object";
import { PredictJsonObject } from "../classes/predict-json-object";
import { FeedbackMaps, PredictionResultDto, PredictResultServiceProxy } from "@shared/service-proxies/service-proxies";
import { ActivatedRoute } from "@angular/router";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: 'kt-predict-result',
  templateUrl: './predict-result.component.html',
  styleUrls: ['./predict-result.component.scss']
})
export class PredictResultComponent implements OnInit {
  id: string | undefined;
  formButtonIsVisible: string | undefined;

	nesneAlgilamaSonucuObject: PredictionResultDto;
	predictJsonObject = new BehaviorSubject<PredictJsonObject>(null);

	borders = new BehaviorSubject<BorderObject[]>([]);
	imageUrl = new BehaviorSubject<string>("");
	labelSummaries = new BehaviorSubject<{ [key: string]: string }>({});
	displayedLabelSummaries = new BehaviorSubject<{ [key: string]: string }>({});
	
	feedbackMap: { [key: string]: string } = {};	//Tablo üzerinde girilen geribildirim mesajlarını array olarak tutabilmek için oluşturuldu	
	globalFeedback = '';

	imageWidth: number;
	imageHeight: number;

	labelBackgroundColor: boolean = false;
	isChecked: boolean = false;
	isVisible: boolean = true;
	gizliGoruntuleButonLabel: string;
	zIndexValue: number;
	labelString: string;

	//---------------------------
	index: number = 0;
	productCount: number;
	borderArray: BorderObject[];

	/**
	 * Form gonderilirken bu deger true degerini alir.
	 */
	isFormSending = new BehaviorSubject<boolean>(false);

	constructor(private _route: ActivatedRoute, private _predictResultService: PredictResultServiceProxy) {
		//URL üzerinden ilgili kayıdın GUID id  bilgisi alınır ve yerel değişkene inject edilir.
		this._route.paramMap.subscribe((params) => {
			this.id = params.get("id");
			this.formButtonIsVisible = params.get("b");
			console.log("id", this.id);
			console.log("buttonParam:", this.formButtonIsVisible);
		});
	}

	ngOnInit() {
		//Sayfa yüklenirken API bağlantısı üzerinden EKOMPLATOM -> Platom Tanımları -> NesneAlgilamaSonuclari entity üzerindeki ilgili kayıdın bilgilerini çeker ve
		//yerel değişkenlere aktarır. Böylelikle sayfada görsel üzerindeki borderlamaları, checkboxları, labelları gibi diğer işlemlerin
		//yürütülmesi yerel değişkenler üzerinden yapılır.
		//Sayfa yüklenirken sunucu tarafının beklenilmesi için BehaviorSubject<> kullanıldı. 
		this._predictResultService.getImagePredictionResult(this.id).subscribe(
			(result) => {
				console.log("PredictionResult:", result);
		  
			  if (!result) {
				alert("API response is null or undefined.");
				return;
			  }
		  
			  this.nesneAlgilamaSonucuObject = result;
		  
			  if (result.predictJson) {	
				try {
				  const parseJsonObject = JSON.parse(result.predictJson);
		  
				  this.predictJsonObject.next(parseJsonObject);
				  this.borders.next(parseJsonObject.predict_results);
				  this.imageUrl.next(parseJsonObject.request_image_url);
				  this.labelSummaries.next(parseJsonObject.label_summary);

				  // Tüm labelları feedbackMap içine başlangıçta ekle
				  Object.keys(this.labelSummaries.value).forEach(label => {
					this.feedbackMap[label] = ''; // Her bir key için başlangıç değeri boş string
				  });				  
		  
				  //console.log("Borders:", this.predictJsonObject);
				  //console.log("ImageUrl:", this.imageUrl);
				  //console.log("LabelSummaries:", this.labelSummaries);
				  //Borderlar içerisinde isExcluded = true olanların tablodaki "Toplam ürün miktarına oranı" alanında hesaplamaya dahil olmaması için gereken verileri topluyorum
				  //this.filteredBorders = this.borders.value.filter(b => b.isExcluded);
				  //this.isExcludedCount = this.borders.value.filter(b => b.isExcluded).length;				  

				  this.filterLabelSummaries();
				  this.updateProductCount();
				} catch (error) {
				  //console.error("JSON parse error:", error);
				  alert("PredictJson verisi hatalı formatta.");
				}
			  } else {
				alert("PredictJson is empty or undefined.");
			  }
			},
			(error) => {
			  //console.error("API Call Failed:", error);
			  alert(this.id + " için API çağrısı başarısız oldu. Lütfen tekrar deneyin.");
			}
		  );	
				  
    	  
	}

	//Bir checkbox'a bağlandı.
	//Görsel üzerine çizdirilen tüm borderları bir kerede isSelected = true yapar daha sonra rengini düzenlemesi için diğer methodu tetikler.
	setAllSelected(borders: BorderObject[]) {
		if (this.isChecked) {
			borders.forEach((element) => {
				element.isSelected = true;
				this.getBorderStyle(element);
			});
		} else {
			borders.forEach((element) => {
				element.isSelected = false;
				this.getBorderStyle(element);
			});
		}
	}

	updateProductCount() {
		// Borderlar gelince borders array'inin uzunluğuna göre ürün sayısını set ediyor.
		this.borderArray = this.borders.getValue();
		//this.productCount = this.borderArray.length;

		//Toplam ürün miktarına oranı hesaplanırken isExcluded = true olan ifadeler hesaplamadan çıkarılması için 
		// labelSummaries üzerinde gelen değerlere göre toplam ürünler hesaplanır.
		//LabelSummaries içerisindeki bütün value değerleri toplam değer olarak kabul edilir. 
		this.productCount = Object.values(this.labelSummaries.value)
  			.map(v => Number(v))       // string → number
  			.reduce((acc, curr) => acc + curr, 0);
	}

	//Tablo üzerinde görüntülenecek olan label_summaries için displayedLabelSummaries filtreleniyor. "0" olanlar gösterilmez.
	//Liste içerisinde görüntülenecek olan label_summaries için predict_results içerisindeki tüm tagname'i eşleşenler gösterilir. Çünkü isExcluded olup "0" olanlar olabilir.
	filterLabelSummaries() {
		// Border'ları al
		const borders = this.borders.getValue();

		// Tagname'leri alıp distinct yap
		const distinctTags = Array.from(
			new Set(borders.map(border => border.tagname))
		);
		
		// Yeni labels objesi oluştur
		const newLabels: { [key: string]: string } = {};
		const newDisplayedLabels: { [key: string]: string } = {};

		const existingLabels = this.labelSummaries.getValue();

		distinctTags.forEach(tag => {
			const existingValue = existingLabels[tag];

			// Tüm labelları listeye ekle
			newLabels[tag] = existingValue || "";

			// Görüntülenecekleri ayrı tut (0 olmayanlar)
			if (existingValue !== "0") {
			newDisplayedLabels[tag] = existingValue;
			}
		});

		// BehaviorSubject'leri güncelle
		this.labelSummaries.next(newLabels);
		this.displayedLabelSummaries.next(newDisplayedLabels);
	}

	//img (load) evente bağlıyoruz. Görselin en ve boyunu yerel değişkene alır.
	getImageSize(image: HTMLImageElement) {
		this.imageWidth = image.width;
		this.imageHeight = image.height;
	}

	//LabelSummary başlığı ile borderlar üzerindeki tagname'e göre kıyaslama yapar. Böylelikle ilgili border için ilgili labelsummary ayırt edilir.
	//LabelSummary ve tagname arasında aynı değere sahip olan borderlar için true değeri döner.
	//borderlar ile checkboxları eşleştirmede kullanıyoruz.
	checkSummaryAndTagname(summary: string, tagname: string): boolean | any {
		if (summary === tagname) {
			return true;
		} else {
			return false;
		}
	}

	//Görsel üzerinde çizilecek borderların özelliklerini ayarlar
	getBorderStyle(border: BorderObject) {
		return {
			title: border.tagname,
			top: border.bounding_box.left * this.imageHeight + "px",
			left: border.bounding_box.top * this.imageWidth + "px",
			width: border.bounding_box.width * this.imageWidth - border.bounding_box.top * this.imageWidth + "px",
			height: border.bounding_box.height * this.imageHeight - border.bounding_box.left * this.imageHeight + "px",
			//borderColor: border.isSelected ? '#19CE0B': '#CE0B0B'
		};
	}

	//Borders içerisinde birde fazla ürün için border listesi olursa array içerisindeki index sırasına göre
	//borderların farklı renklere sahip olması için CSS class isimlerini html tarafı için return eder.
	getBorderColorClass(index: number) {
		if (index === 0) {
			return "border-success";
		} else if (index === 1) {
			return "border-success1";
		} else if (index === 2) {
			return "border-success2";
		} else if (index === 3) {
			return "border-success3";
		} else if (index === 4) {
			return "border-success4";
		} else if (index === 5) {
			return "border-success5";
		} else if (index === 6) {
			return "border-success6";
		} else if (index === 6) {
			return "border-success6";
		} else if (index === 7) {
			return "border-success7";
		} else if (index === 8) {
			return "border-success8";
		} else if (index === 9) {
			return "border-success9";
		} else if (index === 10) {
			return "border-success10";
		} else {
			return "border-success-default";
		}
	}

	//LabelSummaries içerisinde birde fazla ürün için label listesi olursa array içerisindeki index sırasına göre
	//labelların farklı renklerde arkaplana sahip olması için CSS class isimlerini html tarafı için return eder.
	getLabelColorClass(index: number) {
		if (index === 0) {
			return "label-success";
		} else if (index === 1) {
			return "label-success1";
		} else if (index === 2) {
			return "label-success2";
		} else if (index === 3) {
			return "label-success3";
		} else if (index === 4) {
			return "label-success4";
		} else if (index === 5) {
			return "label-success5";
		} else if (index === 6) {
			return "label-success6";
		} else if (index === 7) {
			return "label-success7";
		} else if (index === 8) {
			return "label-success8";
		} else if (index === 9) {
			return "label-success9";
		} else if (index === 10) {
			return "label-success10";
		} else {
			return "label-success-default";
		}
	}

	calcPercentage(value: number): string {
		if (this.productCount === 0) {
			return "0.00";
		}
		const percentage = (value / this.productCount) * 100;
		return percentage.toFixed(2);
	}

	//Bu method ile görsel üzerindeki borderları kullanıcı tarafından onaylanan nihai halini CRM -> entity üzerinde
	//ilgili kayıdın predictJSON alanını günceller.
	sendApprovedBorder() {
		// this.predictJsonObject.value.predict_results = this.borders;

		//let pp = this.predictJsonObject.getValue().predict_results = this.borders

		// let jsPredictJsonObject = JSON.stringify(this.predictJsonObject.value);

		this.isFormSending.next(true);

		this.nesneAlgilamaSonucuObject.predictJson = JSON.stringify(this.predictJsonObject.value);

		this._predictResultService.updateImagePredictionResult(this.nesneAlgilamaSonucuObject).subscribe(
			(response) => {
				alert("İşlem tamamlandi");
			},
			(error) => {
				alert("Form gönderilirken bir sorun ile karşılaşıldı!");
			},
			() => {
				this.isFormSending.next(false);
			}
		);
	}

	changeBorderVisible() {				
	    //Checkboxları (isSelected) sıfırlama
		const borders = this.borders.getValue();
		if (this.isVisible === true)
		{
			borders.forEach(border => {
				border.isSelected = false;				
			});
		}
		else
		{
			borders.forEach(border => {
				border.isSelected = true;				
			});			
		}
	
		// BehaviorSubject'i güncelle
		this.borders.next(borders);

		this.isVisible = !this.isVisible;
	}

	onCheckboxChange(border: BorderObject) {
		if (border.isSelected) {
		  this.isVisible = true; // Border görünürlüğünü etkinleştir
		}
	
		const borders = this.borders.getValue();
		this.borders.next(borders);
	}

	updateFeedback(label: string, comment: string): void {
		if (!comment.trim()) {
		  // Eğer yorum boşsa, listeyi temizle
		  this.feedbackMap[label] = comment;
		} else {
		  // Yorum boş değilse listeyi güncelle
		  this.feedbackMap[label] = comment;
		}
		//console.log(this.feedbackMap);
	}

	updateGlobalFeedback(value: string): void{
		this.globalFeedback = value.trim();
		//console.log('Globak Feedback:', this.globalFeedback);
	}

	sendFeedbackText(){
		// Bu metot kullanıcıların geribildirim girdiği alanların API'a gönderilmesini sağlar.
		// console.log("FeedbackMap:", this.feedbackMap);
		// console.log("Global Feedback:", this.globalFeedback);

		var feedbackList = this.convertToFeedbackMaps();

		console.log("Converted FeedbackList:", feedbackList);
		this._predictResultService.setFeedback(this.id, feedbackList, this.globalFeedback).subscribe({
			next: (result) => {
				alert("Geri bildiriminiz başarı ile gönderildi.");
			},
			error: (error) => {
				alert("Geri bildirim gönderiminde hata oluştu:" + error.toString());
			},
		});
	}

	// API'ye gönderilecek FeedbackMaps listesi
	convertToFeedbackMaps(): FeedbackMaps[] {
		const feedbackList: FeedbackMaps[] = [];
	
		for (const [key, value] of Object.entries(this.feedbackMap)) {
		  const feedback = FeedbackMaps.fromJS({ label: key, comment: value });
		  feedbackList.push(feedback);
		}
	
		return feedbackList;
	}	
}